(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4178],{

/***/ 16311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82476);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75653);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11859);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25935);
/* harmony import */ var _utils_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20558);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85518);
/* harmony import */ var _components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45138);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86466);
/* harmony import */ var _components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59192);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34846);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34326);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71025);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73962);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19514);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11873);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(11310);




















const UpSellInstallServicesCarousalSlick = (param)=>{
    let { upSellData =[] , currency , authData ={} , handleAddToCart =()=>{} , slickRef , addServiceToCart =()=>{} , isSearchClick ="" , inventoryUpdate =0  } = param;
    const { upSellServiceData: { productTitleUpSell ="" , serviceAvailableTitleUpSell ="" , serviceAvailableDescUpsell ="" , toolTipsUpSell ="" , learnAboutUpSell ="" , priceGuardUpSell ="" , toolTipsDescUpSell ="" , outOfStockTitle ="" , includeTitle ="" , recommendationTitle ="" , selectedTitle ="" , presetConfigsUpSellProduct: productPresetConfigs , swatchUrlUpSell: baseUrlImage = ""  } = {}  } = authData;
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_14__.getUserPersona)();
    const [tooltip, setTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        buyMoreSaveMore: false
    });
    const [includedItems, setIncludedItems] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [brandName, setBrandName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kohler");
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const rowCols = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getRowCols */ .n)(width, react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isMobile */ .tq, react_device_detect__WEBPACK_IMPORTED_MODULE_8__/* .isTablet */ .Em);
    let arrowLabel = "Next";
    const slickSettings = (0,_components_Default_CarouselSlick_v1_SlickSettings__WEBPACK_IMPORTED_MODULE_11__/* .singleSliderSettings */ .N)((_, current)=>{}, 0, false, 500, (label)=>{
        arrowLabel = label;
    }, false, (currentIndexAfterChange)=>{
        const currentSlideServiceData = upSellData[eval(currentIndexAfterChange)];
        if (!isSearchClick) {
            (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForArrows */ .X1)(arrowLabel, currentSlideServiceData, currentIndexAfterChange, persona, serviceAvailableTitleUpSell, recommendationTitle);
        }
    });
    slickSettings["infinite"] = false;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        callToConfiguration();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (upSellData.length) {
            makeDefaultSelection();
        }
    }, [
        upSellData,
        inventoryUpdate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const makeDefaultSelection = ()=>{
        const includedRequiredItems = {};
        upSellData.forEach((item)=>{
            const { installServiceData: { discountedPrice =0 , price =0 , skuId: serviceSkuId = ""  } = {} , cartProductData: { sku: parentSku = "" , quantity =1 , custom ={}  } = {}  } = item;
            let { requiredItems =[]  } = item;
            const zeroValues = requiredItems.filter((obj)=>obj["availableQuantity"] === 0);
            const nonZeroValues = requiredItems.filter((obj)=>obj["availableQuantity"] !== 0);
            requiredItems = [
                ...nonZeroValues,
                ...zeroValues
            ];
            includedRequiredItems[parentSku] = {
                subTotal: getSubTotal(requiredItems, parentSku) + (discountedPrice || price) * quantity,
                includedItems: {
                    ...requiredItems.reduce((obj, cur)=>{
                        var ref, ref1;
                        return {
                            ...obj,
                            [cur.sku_s]: {
                                check: cur.availableQuantity > 0,
                                quantity: 1,
                                availableQuantity: cur.availableQuantity,
                                productcategory: cur.Product_Category,
                                productname: cur.ProductBrandName_s || cur.ProductDescriptionProductShort_s,
                                project_img: (ref = cur.productImages) === null || ref === void 0 ? void 0 : ref.labelWithUrl_ss[0],
                                product_decs: cur.ProductDescriptionProductShort_s,
                                warehouses: (cur === null || cur === void 0 ? void 0 : (ref1 = cur.warehouse) === null || ref1 === void 0 ? void 0 : ref1.length) && (cur === null || cur === void 0 ? void 0 : cur.warehouse)
                            }
                        };
                    }, {})
                },
                serviceCheckStatus: !!serviceSkuId,
                serviceQty: quantity
            };
        });
        setIncludedItems(includedRequiredItems);
    };
    const callToConfiguration = async ()=>{
        const config = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_17__/* .getConfig */ .i)();
        const { general: { siteName ="kohler"  } = {}  } = config !== null && config !== void 0 ? config : {};
        setBrandName(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase());
    };
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndpoints: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_17__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    const getSubTotal = function() {
        let requiredItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        return requiredItems.reduce((n, param)=>{
            let { ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , sku_s: sku = "" , availableQuantity =0  } = param;
            var ref;
            let quantity = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) ? (ref = availableParentSku.includedItems[sku]) === null || ref === void 0 ? void 0 : ref.quantity : 1;
            skuId && sku === skuId ? quantity = qty : quantity;
            const price = availableQuantity ? discountedPrice || productPrice : 0;
            return n + price * quantity;
        }, 0);
    };
    const checkChangeHandlerForService = function(e) {
        let parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, installServiceData = arguments.length > 3 ? arguments[3] : void 0;
        const { target: { checked =false  } = {}  } = e;
        handleServiceOperations(checked, parentSku, index);
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__.addAnalyticsForIncludeforInstallservice)(checked, includeTitle, recommendationTitle, installServiceData, index);
    };
    const handleServiceOperations = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, qty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, handleQtyChange = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            var _installServiceData;
            const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
            const { discountedPrice =0 , price =0  } = serviceData;
            let servicePrice = availableParentSku.serviceCheckStatus ? (discountedPrice || price) * qty : 0;
            if (handleQtyChange) {
                if (availableParentSku.serviceCheckStatus) {
                    var ref, ref;
                    const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                        var ref;
                        return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
                    });
                    if ((ref = upSellData[index]) === null || ref === void 0 ? void 0 : (ref = ref.requiredItems) === null || ref === void 0 ? void 0 : ref.length) {
                        const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
                        const total = getSubTotal(requiredFilteredItems, parentSku) + servicePrice;
                        availableParentSku.subTotal = total;
                    }
                }
                availableParentSku.serviceQty = qty;
            } else {
                const operand = checked ? "+" : "-";
                availableParentSku.serviceCheckStatus = checked;
                const serviceQty = availableParentSku.serviceQty;
                servicePrice = (discountedPrice || price) * serviceQty;
                const { subTotal =0  } = availableParentSku;
                availableParentSku.subTotal = eval(subTotal + operand + servicePrice);
            }
            setIncludedItems(addedItems);
        }
    };
    const checkChangeHandlerForReqItems = function() {
        let checked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku)) {
            availableParentSku.includedItems[skuId].check = checked;
            if (index > -1) {
                const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                    var ref;
                    return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
                });
                const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
                var _installServiceData;
                const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
                const { discountedPrice =0 , price =0  } = serviceData;
                const servicePrice = availableParentSku.serviceCheckStatus ? (discountedPrice || price) * (availableParentSku.serviceQty || 1) : 0;
                availableParentSku.subTotal = getSubTotal(requiredFilteredItems, parentSku) + servicePrice;
            }
            setIncludedItems(addedItems);
        }
    };
    const handleChange = function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", index = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1, action = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, installServiceData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, item = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
        if (parentSku && index > -1) {
            handleServiceOperations(true, parentSku, index, qty, true);
            (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__.addAnalyticsForQuantitySelectorforinstallservice)(index, action, installServiceData, item, qty);
        }
    };
    const quantityChangeHanlder = function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, parentSku = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", skuId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1, action = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, requiredItemsProductdata = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, childindex = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : -1, installServiceDataAvailable = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : "", cartProductData = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {}, setQuantity = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : ()=>{};
        setQuantity(qty);
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            const checkedSkus = Object.keys(availableParentSku.includedItems).filter((key)=>{
                var ref;
                return (ref = availableParentSku.includedItems[key]) === null || ref === void 0 ? void 0 : ref.check;
            });
            const requiredFilteredItems = upSellData[index].requiredItems.filter((item)=>checkedSkus.some((sku)=>item.sku_s === sku));
            availableParentSku.includedItems[skuId].quantity = qty;
            var _installServiceData;
            const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
            const { discountedPrice =0 , price =0  } = serviceData;
            const servicePrice = availableParentSku.serviceCheckStatus ? discountedPrice || price : 0;
            const total = getSubTotal(requiredFilteredItems, parentSku, skuId, qty) + servicePrice;
            availableParentSku.subTotal = total;
            setIncludedItems(addedItems);
        // addAnalyticsForQuantitySelectorforRequiredproduct(
        //   action,
        //   requiredItemsProductdata,
        //   index,
        //   installServiceDataAvailable ? childindex + 1 : childindex,
        //   persona,
        //   qty,
        //   cartProductData,
        //   installServiceDataAvailable
        // )
        }
    };
    const handleFieldInfoMouseOver = function() {
        let tooltipFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "buyMoreSaveMore", value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setTooltip({
            ...tooltip,
            [tooltipFor]: value
        });
    };
    const addTocarthandler = function(item, index, parentSku, serviceName, title, cartProductData, mainTitle, upSellDataIndex) {
        let installServiceData = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : {};
        const isChildren = true;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        let qty = 1;
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            qty = availableParentSku.serviceQty;
        }
        const isCartAction = true;
        handleAddToCart(item, qty);
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, title, "", cartProductData, mainTitle, upSellDataIndex, 1, isChildren, item, qty, isCartAction);
    };
    const installserviceClickHandler = function(e, serviceName, cartProductData) {
        let upSellDataIndex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", item = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
        const isChildren = true;
        const { target: { href ="" , textContent =""  } = {}  } = e;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, textContent.toLowerCase(), href, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, isChildren, item);
    };
    const priceGuardClickHandler = function(e, serviceName, cartProductData) {
        let title = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", upSellDataIndex = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", item = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
        const isChildren = true;
        const { target: { href ="" , textContent =""  } = {}  } = e;
        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName.toLowerCase(), textContent.toLowerCase(), href, cartProductData, title, upSellDataIndex, 1, isChildren, item);
    };
    const addSelectedItem = function() {
        let parentSku = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1, subTotal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, item = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        if (!parentSku) return;
        const addedItems = {
            ...includedItems
        };
        const availableParentSku = addedItems[parentSku];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(availableParentSku) && index > -1) {
            const requiredItems = availableParentSku.includedItems;
            const selectedItems = Object.keys(requiredItems).filter((key)=>requiredItems[key].check).map((item)=>{
                var ref, ref1;
                return {
                    sku: item,
                    quantity: (ref = requiredItems[item]) === null || ref === void 0 ? void 0 : ref.quantity,
                    warehouses: (ref1 = requiredItems[item]) === null || ref1 === void 0 ? void 0 : ref1.warehouses
                };
            });
            if (availableParentSku.serviceCheckStatus && index > -1) {
                var _installServiceData;
                const serviceData = (_installServiceData = upSellData[index].installServiceData) !== null && _installServiceData !== void 0 ? _installServiceData : {};
                const { skuId =""  } = serviceData;
                var _serviceQty;
                selectedItems.push({
                    sku: skuId,
                    quantity: (_serviceQty = availableParentSku.serviceQty) !== null && _serviceQty !== void 0 ? _serviceQty : 1
                });
            }
            if (selectedItems.length) {
                const cartItems = selectedItems.map((item)=>({
                        ...item,
                        brand: brandName,
                        section: _utils_constants__WEBPACK_IMPORTED_MODULE_19__/* .productSections.RECOMMENDATIONS */ .Oy.RECOMMENDATIONS
                    }));
                const requiredItemsForAnalytics = upSellData[index].requiredItems;
                const serviceInfo = upSellData[index].installServiceData;
                const installServiceDataAnlytics = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(serviceInfo) ? {
                    ["ProductDescriptionProductShort_s"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.description,
                    ["Product_Category"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.productCategory,
                    image: "".concat(serviceInfo.swatchUrl).concat(serviceInfo.images, "?$SellModalDesktop$"),
                    unitPrice: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.discountedPrice,
                    customerFacingSKU: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.customerFacingSKU,
                    productTileName: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.name,
                    ["CustomerFacingBrand_s"]: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.customerBrand,
                    availableQuantity: 1,
                    sku_s: serviceInfo === null || serviceInfo === void 0 ? void 0 : serviceInfo.skuId,
                    productParentImage: "".concat(serviceInfo.swatchUrl).concat(serviceInfo.images, "?$SellModalDesktop$")
                } : {};
                const requiredItemsArray = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceDataAnlytics) ? [
                    installServiceDataAnlytics,
                    ...requiredItemsForAnalytics
                ] : [
                    ...requiredItemsForAnalytics
                ];
                const productinfo = [];
                const allSelectedProductInfo = requiredItemsArray;
                allSelectedProductInfo.forEach((productItem, childindex)=>{
                    var ref;
                    const matchedItem = (ref = selectedItems.find((selItem)=>productItem.sku_s === selItem.sku)) !== null && ref !== void 0 ? ref : {};
                    if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(matchedItem)) {
                        const { quantity: totalQTY = 1  } = matchedItem;
                        productinfo.push({
                            ...productItem,
                            childindex,
                            index,
                            totalQTY
                        });
                    }
                });
                addServiceToCart(cartItems);
                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForADDtoCart */ .J_)(productinfo, availableParentSku.serviceCheckStatus, serviceInfo, persona, availableParentSku.serviceQty, subTotal);
            }
        }
    };
    const getSelectedItemNum = function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { includedItems ={} , serviceCheckStatus =false  } = item;
        let num = 0;
        for(const key in includedItems){
            if (includedItems.hasOwnProperty(key)) {
                var ref;
                if ((ref = includedItems[key]) === null || ref === void 0 ? void 0 : ref.check) num += 1;
            }
        }
        if (serviceCheckStatus) num = num + 1;
        return num;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ref: slickRef,
        ...slickSettings,
        children: upSellData.map((item, upSellDataIndex)=>{
            var ref, ref1;
            const { cartProductData ={} , cartProductData: { name ="" , quantity =1 , sku ="" , customerFacingSKU ="" , unitPrice =0 , currencySign =currency , image =""  } = {} , installServiceData: { quantity: installQuantity , name: serviceName = "" , description ="" , discountedPrice =0 , price =0 , images ="" , skuId: serviceSku = "" , presetConfigs: imgConfigs = {} , swatchUrl: baseUrl  } = {} , installServiceData ={} , requiredItems =[]  } = item;
            const imgUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, images, imgConfigs, true);
            const imgId = image === null || image === void 0 ? void 0 : image.split("/").at(-1);
            const parsedConfigs = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(productPresetConfigs) ? JSON.parse(productPresetConfigs) : {};
            const productImageUrl = (0,_utils_index__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrlImage, imgId, parsedConfigs);
            const subTotal = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? (ref = includedItems[sku]) === null || ref === void 0 ? void 0 : ref.subTotal : 0;
            const selectedIncludesNum = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? getSelectedItemNum(includedItems[sku]) : 0;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "upsell-modal__container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_ParentProductCard__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                productTitleUpSell: productTitleUpSell,
                                productImageUrl: productImageUrl,
                                customerFacingSKU: sku,
                                name: name,
                                quantity: quantity,
                                unitPrice: unitPrice,
                                currencySign: currencySign,
                                outOfStockTitle: outOfStockTitle,
                                includeTitle: includeTitle,
                                containerClassName: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "right-side",
                                children: !requiredItems.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "title",
                                            children: serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "description",
                                            children: serviceAvailableDescUpsell
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "installation-services",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "installation-services__left",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__image",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: imgUrl,
                                                                alt: serviceName
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__links",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__learn-more",
                                                                    role: "link",
                                                                    onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                                    children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price-guard",
                                                                    role: "link",
                                                                    onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                                    children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "installation-services__right",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__right--mobile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__title",
                                                                    children: serviceName
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price--moblie",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                        discountedPrice: discountedPrice,
                                                                        price: price,
                                                                        currencySign: currency
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__description",
                                                            children: description
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__sku",
                                                            children: skuPrependName.toLowerCase() === serviceSku.substring(0, 2).toLowerCase() ? serviceSku : "".concat(skuPrependName ? skuPrependName : "").concat(serviceSku)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "installation-services__price",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                discountedPrice: discountedPrice,
                                                                price: price,
                                                                currencySign: currency
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__add-to-cart",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__quantity-selector",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                        size: "small",
                                                                        value: installQuantity,
                                                                        source: "cart-landing",
                                                                        onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "add-to-cart",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                        role: "button",
                                                                        label: "Add To Cart",
                                                                        onClick: ()=>addTocarthandler(item, upSellDataIndex, sku, serviceName, "add to cart", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null, upSellDataIndex, installServiceData),
                                                                        size: "large",
                                                                        type: "primary",
                                                                        flexible: true
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__tool-tip",
                                                            onMouseOver: ()=>{
                                                                handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                            },
                                                            onFocus: ()=>{
                                                                handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                                (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                            },
                                                            onMouseLeave: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                            onBlur: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__tool-tip ".concat(tooltip.buyMoreSaveMore ? "--show" : "--hide"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "installation-services__tool-tip-wrapper",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_ToolTip_ToolTip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                                            message: toolTipsDescUpSell
                                                                        })
                                                                    })
                                                                }),
                                                                toolTipsUpSell
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "installation-services__links--mobile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__learn-more",
                                                                    role: "link",
                                                                    onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                                    children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "installation-services__price-guard",
                                                                    role: "link",
                                                                    onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                                    children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "installation-services__mobile-landscpae",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mobile-landscpae__add-to-cart",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__quantity-selector",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                size: "small",
                                                                value: installQuantity,
                                                                source: "cart-landing",
                                                                onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__button-to-cart",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                role: "button",
                                                                label: "Add To Cart",
                                                                onClick: ()=>addTocarthandler(item, upSellDataIndex, sku, serviceName, "add to cart", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : null, upSellDataIndex),
                                                                size: "large",
                                                                type: "primary",
                                                                flexible: true
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "mobile-landscpae__tool-tip",
                                                    onMouseOver: ()=>{
                                                        handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                    },
                                                    onFocus: ()=>{
                                                        handleFieldInfoMouseOver("buyMoreSaveMore", true);
                                                        (0,_components_Shared_UpsellInstallServices_analytics__WEBPACK_IMPORTED_MODULE_12__/* .addAnalyticsForToolTip */ .sj)(serviceName, "buy more, save more", "", cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, 1, true, item);
                                                    },
                                                    onMouseLeave: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                    onBlur: ()=>handleFieldInfoMouseOver("buyMoreSaveMore", false),
                                                    children: toolTipsUpSell
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mobile-landscpae__links--mobile",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__learn-more",
                                                            role: "link",
                                                            onClick: (e)=>installserviceClickHandler(e, serviceName, cartProductData, upSellDataIndex, item),
                                                            children: learnAboutUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(learnAboutUpSell) : null
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "mobile-landscpae__price-guard",
                                                            role: "link",
                                                            onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, serviceAvailableTitleUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell) : recommendationTitle, upSellDataIndex, item),
                                                            children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "required-parts-right-side",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "required-item-header",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "required-item-title",
                                                    children: recommendationTitle
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "subtotal-add-to-cart",
                                                    children: [
                                                        subTotal > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "required-item-price",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "selected",
                                                                    children: "".concat(selectedTitle, " (").concat(selectedIncludesNum, ")")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                    currencySign: currency,
                                                                    price: subTotal
                                                                })
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "add-to-cart",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                role: "button",
                                                                label: "Update Cart (".concat(selectedIncludesNum, ")"),
                                                                onClick: ()=>addSelectedItem(sku, upSellDataIndex, subTotal, upSellData),
                                                                size: "large",
                                                                type: "primary",
                                                                flexible: true,
                                                                disabled: !subTotal
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "required-item",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "required-item-list",
                                                children: [
                                                    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceData) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "required-item-install-service",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__img",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: imgUrl,
                                                                    alt: serviceName
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__title",
                                                                children: serviceName
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "required-item-install-service__sku",
                                                                children: skuPrependName.toLowerCase() === serviceSku.substring(0, 2).toLowerCase() ? serviceSku : "".concat(skuPrependName ? skuPrependName : "").concat(serviceSku)
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "required-item-install-service__price-quantity",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "required-item-install-service__price",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                            discountedPrice: discountedPrice,
                                                                            price: price,
                                                                            currencySign: currencySign
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "required-item-install-service__quantity",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                                            doNotRequiredAnalyticsData: true,
                                                                            productdata: cartProductData,
                                                                            size: "small",
                                                                            value: installQuantity,
                                                                            source: "cart-landing",
                                                                            onChange: (qty, action)=>handleChange(qty, sku, upSellDataIndex, action, installServiceData, item)
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "required-item-install-service__include",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "include-div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "checkbox",
                                                                                children: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(includedItems) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                                                    checked: (ref1 = includedItems[sku]) === null || ref1 === void 0 ? void 0 : ref1.serviceCheckStatus,
                                                                                    onChange: (e)=>checkChangeHandlerForService(e, sku, upSellDataIndex, installServiceData)
                                                                                }) : null
                                                                            }),
                                                                            includeTitle
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "price-gurd-link",
                                                                        role: "link",
                                                                        onClick: (e)=>priceGuardClickHandler(e, serviceName, cartProductData, recommendationTitle ? recommendationTitle : (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(serviceAvailableTitleUpSell), upSellDataIndex, item),
                                                                        children: priceGuardUpSell ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(priceGuardUpSell) : null
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : null,
                                                    requiredItems.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_UpsellInstallServices_RequiredProductItem__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                                requiredProductItem: item,
                                                                persona: persona,
                                                                currencySign: currency,
                                                                parsedConfigs: parsedConfigs,
                                                                rowCols: rowCols,
                                                                baseUrl: baseUrlImage,
                                                                parentSku: sku,
                                                                includedItems: includedItems,
                                                                upSellDataIndex: upSellDataIndex,
                                                                updateRequiredItems: checkChangeHandlerForReqItems,
                                                                recommendationTitle: recommendationTitle,
                                                                quantityChangeHanlder: quantityChangeHanlder,
                                                                includeTitle: includeTitle,
                                                                outOfStockTitle: outOfStockTitle,
                                                                index: index,
                                                                installServiceDataAvailable: !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_10___default()(installServiceData),
                                                                cartProductData: cartProductData
                                                            })
                                                        }, item.sku_s))
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    requiredItems.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "subtotal-add-to-cart--mobile",
                        children: [
                            subTotal > 0 && subTotal != "0.00" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "number-total-mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "selected-mobile",
                                        children: "".concat(selectedTitle, " (").concat(selectedIncludesNum, ")")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "total-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            currencySign: currencySign,
                                            price: subTotal
                                        })
                                    })
                                ]
                            }) : null,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "add-to-cart-",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    role: "button",
                                    label: "Update Cart",
                                    onClick: ()=>addSelectedItem(sku, upSellDataIndex),
                                    size: "large",
                                    type: "primary",
                                    flexible: true,
                                    disabled: !subTotal
                                })
                            })
                        ]
                    }) : null
                ]
            }, sku);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(UpSellInstallServicesCarousalSlick));


/***/ }),

/***/ 11873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34846);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57333);
/* harmony import */ var _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36513);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9656);
/* harmony import */ var _components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6__);








var ref;
const ParentProductCard = (param)=>{
    let { productTitleUpSell ="" , productImageUrl =(ref = _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _public_images_image_missing_png__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src) !== null && ref !== void 0 ? ref : "" , customerFacingSKU ="" , name ="" , quantity =1 , unitPrice =0 , currencySign ="" , outOfStockTitle ="" , includeTitle ="" , containerClassName ="" , includedItems ={} , availableQuantity =0 , checkChangeHandlerForParentProduct =()=>{}  } = param;
    var ref1;
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const checkChangeHandler = (e)=>{
        const { target: { checked =false  } = {}  } = e !== null && e !== void 0 ? e : {};
        checkChangeHandlerForParentProduct(checked, customerFacingSKU);
    };
    const isChecked = !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_6___default()(includedItems) ? (ref1 = includedItems[customerFacingSKU]) === null || ref1 === void 0 ? void 0 : ref1.check : false;
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndpoints: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UpsellInstallServices_ParentProductCard_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().leftside),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "productcard",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "left-side".concat(containerClassName),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "head",
                        children: productTitleUpSell
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "left-side--moblie",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "image",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: productImageUrl,
                                    alt: name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "prouct-info--mobile",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-name",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-sku",
                                        children: skuPrependName.toLowerCase() === customerFacingSKU.substring(0, 2).toLowerCase() ? customerFacingSKU : "".concat(skuPrependName ? skuPrependName : "").concat(customerFacingSKU)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-price",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* .NumericFormat */ .h3, {
                                            value: unitPrice,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "product-qty",
                                        children: [
                                            "Qty: ",
                                            quantity
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pdp-upsell",
                                        children: !availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pdp-out-of-stock",
                                            children: outOfStockTitle
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "pdp-include-div",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pdp-checkbox",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                        checked: isChecked,
                                                        onChange: checkChangeHandler
                                                    })
                                                }),
                                                includeTitle
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParentProductCard);


/***/ }),

/***/ 73962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19514);
/* harmony import */ var _components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75653);
/* harmony import */ var _components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34846);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11859);
/* harmony import */ var _components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71025);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20558);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77145);
/* harmony import */ var _components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59192);










const RequiredProductItem = (param)=>{
    let { persona ="GST" , requiredProductItem ={} , currencySign ="$" , parsedConfigs ={} , rowCols =0 , baseUrl ="" , parentSku ="" , includedItems =[] , upSellDataIndex =-1 , quantityChangeHanlder =()=>{} , updateRequiredItems =()=>{} , includeTitle ="" , recommendationTitle ="" , outOfStockTitle ="" , showQtyInput =true , dynamicClass ="" , index =1 , installServiceDataAvailable =false , cartProductData ={}  } = param;
    var ref, ref1;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        checkSkuKPrepend();
    }, []);
    const [skuPrependName, setSkuPrependName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const { sku_s: skuId = "" , ProductBrandName_s: productBrandName = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: productImage = [] , availableQuantity =1 , warehouse ="undefined"  } = requiredProductItem;
    let imgId = "";
    if (productImage.length) {
        var ref2, ref3;
        const index1 = productImage.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref3 = (ref2 = productImage[index1]) === null || ref2 === void 0 ? void 0 : ref2.split("|")) === null || ref3 === void 0 ? void 0 : ref3.length) ? productImage[index1].split("|")[1] : "";
        imgId = assetId;
    }
    const requiredProdImgUrl = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .getPresetUrl */ .v$)(width, rowCols, baseUrl, imgId, parsedConfigs);
    var ref4;
    const isChecked = (ref4 = (ref1 = (ref = includedItems[parentSku]) === null || ref === void 0 ? void 0 : ref.includedItems[skuId]) === null || ref1 === void 0 ? void 0 : ref1.check) !== null && ref4 !== void 0 ? ref4 : false;
    const checkChangeHandler = (e, requiredProductItem)=>{
        var ref, ref1;
        const { target: { checked =false  } = {}  } = e;
        updateRequiredItems(checked, parentSku, skuId, upSellDataIndex);
        var ref2;
        const qty = (ref2 = (ref1 = (ref = includedItems[parentSku]) === null || ref === void 0 ? void 0 : ref.includedItems[skuId]) === null || ref1 === void 0 ? void 0 : ref1.quantity) !== null && ref2 !== void 0 ? ref2 : 1;
        (0,_analytics__WEBPACK_IMPORTED_MODULE_8__/* .addAnalyticsForIncludeforRequiredItem */ .bP)(checked, includeTitle, recommendationTitle, requiredProductItem, upSellDataIndex, installServiceDataAvailable ? index + 1 : index, persona, "", qty);
    };
    const checkSkuKPrepend = async ()=>{
        var ref;
        const { apiEndpoints: { skuPrepend =""  } = {}  } = (ref = await (0,_constants_config__WEBPACK_IMPORTED_MODULE_2__/* .getConfig */ .i)()) !== null && ref !== void 0 ? ref : {};
        setSkuPrependName(skuPrepend);
    };
    const [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_Shared_UpsellInstallServices_RequiredProductItem_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().requireditem),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "required-item-for-install-service".concat(dynamicClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__img",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: requiredProdImgUrl,
                        alt: productBrandName
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__title",
                    children: productBrandName || productName
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__sku",
                    children: skuPrependName.toLowerCase() === skuId.substring(0, 2).toLowerCase() ? skuId : "".concat(skuPrependName ? skuPrependName : "").concat(skuId)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "required-item-for-install-service__price-quantity",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "required-item-for-install-service__price",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_DisplayDiscountPrice__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                discountedPrice: discountedPrice,
                                price: productPrice,
                                currencySign: currencySign
                            })
                        }),
                        showQtyInput && availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "required-item-for-install-service__quantity",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_QuantitySelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                size: "small",
                                source: "cart-landing",
                                value: quantity,
                                setQuantity: ()=>setQuantity,
                                onChange: (qty, action)=>quantityChangeHanlder(qty, parentSku, skuId, upSellDataIndex, action, requiredProductItem, index, installServiceDataAvailable, cartProductData, setQuantity)
                            })
                        }) : null
                    ]
                }),
                warehouse === "undefined" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "inventory-loader",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "loading-spinner"
                        }),
                        " Checking inventory..."
                    ]
                }) : !availableQuantity ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "not-in-stock",
                    children: outOfStockTitle
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "required-item-for-install-service__include",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "include-div",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "checkbox",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Checkbox_Checkbox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    checked: isChecked,
                                    onChange: (e)=>checkChangeHandler(e, requiredProductItem)
                                })
                            }),
                            includeTitle
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RequiredProductItem);


/***/ }),

/***/ 64785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UpsellInstallServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/InstallServiceCarousalSlick/index.jsx
var InstallServiceCarousalSlick = __webpack_require__(16311);
// EXTERNAL MODULE: ./utils/helper.js + 2 modules
var helper = __webpack_require__(34326);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/api.js
var api = __webpack_require__(9670);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/utils.js



const getProcessedInstallServiceData = (productServiceData, presetConfigs, swatchUrl, persona, currencySign)=>{
    const productCardProps = {
        presetConfigs: presetConfigs ? JSON.parse(presetConfigs) : "",
        swatchUrl: swatchUrl !== null && swatchUrl !== void 0 ? swatchUrl : "",
        images: MissingImage
    };
    if (!_isEmpty(productServiceData)) {
        // get product images
        let imgSrc = "";
        if (productServiceData["productImages.url_s"]) {
            var ref;
            imgSrc = (ref = productServiceData["productImages.url_s"]) !== null && ref !== void 0 ? ref : "";
        } else if (productServiceData["productImages.url_ss"]) {
            var ref1;
            imgSrc = (ref1 = productServiceData["productImages.url_ss"][0]) !== null && ref1 !== void 0 ? ref1 : "";
        }
        if (imgSrc.length) {
            const imgParts = imgSrc === null || imgSrc === void 0 ? void 0 : imgSrc.split("/");
            const imgId = imgParts[imgParts.length - 1];
            productCardProps.images = imgId;
        }
        // get product colors
        if (productServiceData["Color.SKU.Details_ss"]) {
            var ref2;
            const colors = (ref2 = productServiceData["Color.SKU.Details_ss"]) !== null && ref2 !== void 0 ? ref2 : [];
            productCardProps.colors = colors.filter((item)=>{
                const color = item.split("|");
                return color[4] === "false" || Date.parse(color[4]) > Date.now();
            });
        } else {
            var ref3;
            productCardProps.colors = [
                (ref3 = productServiceData["SKUColorSwatchFilename_s"]) !== null && ref3 !== void 0 ? ref3 : ""
            ];
        }
        // get product web features
        if (productServiceData["ProductWebFeatures_s"]) {
            var ref4;
            productCardProps.productFeatures = (ref4 = [
                productServiceData["ProductWebFeatures_s"]
            ]) !== null && ref4 !== void 0 ? ref4 : [];
        } else {
            var ref5;
            productCardProps.productFeatures = (ref5 = productServiceData["ProductWebFeatures_ss"]) !== null && ref5 !== void 0 ? ref5 : [];
        }
        productCardProps.currencySign = currencySign;
        productCardProps.productCategory = _get(productServiceData, "Product_Category", "");
        productCardProps.name = _get(productServiceData, "productName_s", "");
        productCardProps.brandName = _get(productServiceData, "RegionBrandName_s", "");
        productCardProps.description = _get(productServiceData, "ProductNarrativeDescription_s", "");
        productCardProps.narrativeDescription = _get(productServiceData, "ProductNarrativeDescription_s", "");
        productCardProps.price = _get(productServiceData, "priceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountedPrice = _get(productServiceData, "discountedPriceStartingAt.".concat(persona, "_d"), 0);
        productCardProps.discountPercent = parseInt(_get(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), 0));
        productCardProps.slug = _get(productServiceData, "slug_s", "");
        productCardProps.customerBrand = _get(productServiceData, "CustomerFacingBrand_s", "");
        productCardProps.skuId = _get(productServiceData, "masterSKU_s", "");
        let tempColorDetails = _get(productServiceData, "Color.SKU.Details_s", _get(productServiceData, "Color.SKU.Details_ss", null));
        if (tempColorDetails) {
            if (typeof tempColorDetails !== "string" && tempColorDetails[0]) {
                tempColorDetails = tempColorDetails[0];
            }
            productCardProps.customerFacingSKU = tempColorDetails.split("|")[5] || "";
        }
        productCardProps.badgeVal = _get(productServiceData, "priceList.".concat(persona, ".saleOffer_s"), "");
        productCardProps.globalDiscount = productCardProps.price - _get(productServiceData, "priceList.".concat(persona, ".finalPrice_d"), productCardProps.price);
        productCardProps.priceType = "";
    }
    return productCardProps;
};


// EXTERNAL MODULE: ./src/store/features/locationSlice.js
var locationSlice = __webpack_require__(13644);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/index.module.scss
var index_module = __webpack_require__(48320);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/localization.js
var localization = __webpack_require__(5600);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/analytics/index.js
var analytics = __webpack_require__(59192);
// EXTERNAL MODULE: ./components/Shared/UpsellInstallServices/analytics/constant.js
var constant = __webpack_require__(13926);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button_Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var hooks_useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var utils_cart = __webpack_require__(33273);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/ProductCard.jsx








const ProductCard_ProductCard = (param)=>{
    let { persona ="GST" , currencySign ="$" , brand ="kohler" , presetConfigs ="" , rowCols =0 , swatchUrl: baseUrl = "" , outOfStockTitle ="" , addToCart =()=>{} , ...item } = param;
    const [width] = useWindowResize();
    const [isProductAvailable, setIsProductAvailable] = useState(true);
    const [pdpUrl, setPdpUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const { sku_s: skuId = "" , ProductBrandName_s: name = "" , productName_s: productName = "" , ["priceList.".concat(persona, ".price_d")]: productPrice = 0 , ["priceList.".concat(persona, ".discountedPrice_d")]: discountedPrice = 0 , ["productImages.labelWithUrl_ss"]: labledImages = [] , Product_Category: productCategory = "" , slug_s: slug = ""  } = item;
    useEffect(()=>{
        getPDPUrl(productCategory, slug).then((url)=>setPdpUrl(url));
        checkForProductQuantity();
    }, []);
    const checkForProductQuantity = async ()=>{
        const isInStock = await getStock(skuId);
        setIsProductAvailable(isInStock ? true : false);
    };
    const price = Number(productPrice).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const productPresetConfigs = presetConfigs ? JSON.parse(presetConfigs) : {};
    let imgId = "";
    if (labledImages.length) {
        var ref, ref1;
        const index = labledImages.map((item)=>{
            var ref;
            return ((ref = item.split("|")) === null || ref === void 0 ? void 0 : ref.length) ? item.split("|")[0] : "";
        }).indexOf(skuId);
        const assetId = ((ref1 = (ref = labledImages[index]) === null || ref === void 0 ? void 0 : ref.split("|")) === null || ref1 === void 0 ? void 0 : ref1.length) ? labledImages[index].split("|")[1] : "";
        imgId = assetId;
    }
    const handleAddToCartCb = ()=>{
        setLoading(false);
    };
    const handleAddToCart = (e)=>{
        e.preventDefault();
        setLoading(true);
        const payload = [
            {
                sku: skuId,
                quantity: 1,
                brand: brand === null || brand === void 0 ? void 0 : brand.toLowerCase()
            }
        ];
        addToCart(payload, handleAddToCartCb);
    };
    const productImageUrl = getPresetUrl(width, rowCols, baseUrl, imgId, productPresetConfigs);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.curatedProduct,
        children: /*#__PURE__*/ _jsx("div", {
            className: "curated-product-recommendation__card-list",
            children: /*#__PURE__*/ _jsx("a", {
                href: "".concat(pdpUrl).concat(skuId ? "?skuId=" + skuId : ""),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "curated-product-recommendation__product-card",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__img",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: productImageUrl,
                                alt: name
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__product-name",
                            children: name || productName
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__product-sku",
                            children: skuId
                        }),
                        discountedPrice > 0 ? /*#__PURE__*/ _jsxs("div", {
                            className: "curated-product-recommendation__discounted-price",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "price-with-discount",
                                    children: "".concat(currencySign).concat(discountedPrice)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "original-price",
                                    children: "".concat(currencySign).concat(price)
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__product-price",
                            children: "".concat(currencySign).concat(price)
                        }),
                        !isProductAvailable ? /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__out-of-stock",
                            children: outOfStockTitle
                        }) : /*#__PURE__*/ _jsx("div", {
                            className: "curated-product-recommendation__add-to-cart",
                            children: /*#__PURE__*/ _jsx(Button, {
                                role: "button",
                                label: "Add To Cart",
                                size: "small",
                                type: "primary",
                                flexible: true,
                                onClick: handleAddToCart,
                                loading: loading
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ProductCardForUpsell_ProductCard = (/*#__PURE__*/(/* unused pure expression or super */ null && (memo(ProductCard_ProductCard))));

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./utils/addTocart.js
var addTocart = __webpack_require__(27522);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/ProductCardForUpsell/index.jsx















const ProductCardForUpsell = (param)=>{
    let { authData ={}  } = param;
    const { skuIds =[] , presetConfigs ="" , swatchUrl ="" , outOfStockTitle =""  } = authData;
    const [width] = useWindowResize();
    const dispatch = useDispatch();
    const rowCols = getRowCols(width, isMobile, isTablet);
    const persona = getUserPersona();
    const [recommendedProductData, setRecommendedProductData] = useState([]);
    const [currency, setCurrencySign] = useState("$");
    const [brand, setBrand] = useState("kohler");
    const callToFetchRecommendedProductData = ()=>{
        getConfig().then((config)=>{
            if (!_isEmpty(config)) {
                const { general: { siteName ="kohler"  } = {} , internationalization: { currencySign ="$"  } = {}  } = config;
                getRecommendedProductData({
                    siteName,
                    currencySign
                });
            }
        });
    };
    useEffect(()=>{
        if (persona) callToFetchRecommendedProductData();
    }, [
        persona
    ]);
    const getRecommendedProductData = (param)=>{
        let { siteName ="kohler" , currencySign ="$"  } = param;
        getProductDataFromSkuIds(persona, skuIds, siteName).then((res)=>{
            if (!_isEmpty(res)) {
                const { data: { response: { docs =[]  } = {}  } = {}  } = res;
                setCurrencySign(currencySign);
                setBrand(siteName);
                setRecommendedProductData(docs);
            }
        });
    };
    const handleAddToCart = async function() {
        let items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], cb = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
        const payload = await addToCartItem([
            ...items
        ]);
        const body = {
            actions: payload
        };
        dispatch(addToCart(body)).unwrap().then((res)=>{
            dispatch(showPreviewCart());
            const { payload ={}  } = res;
            if (!_isEmpty(payload)) {
                dispatch(setCart(payload));
            }
            cb();
        }).catch((err)=>{
            cb();
        });
    };
    return /*#__PURE__*/ _jsx("div", {
        className: styles.curatedProduct,
        children: /*#__PURE__*/ _jsx("div", {
            className: "curated-product-recommendation",
            children: recommendedProductData.map((item)=>{
                return /*#__PURE__*/ _jsx(React.Fragment, {
                    children: /*#__PURE__*/ _jsx(ProductCard, {
                        addToCart: handleAddToCart,
                        ...item,
                        persona: persona,
                        currencySign: currency,
                        brand: brand,
                        presetConfigs: presetConfigs,
                        rowCols: rowCols,
                        swatchUrl: swatchUrl,
                        outOfStockTitle: outOfStockTitle
                    })
                }, item.id);
            })
        })
    });
};
/* harmony default export */ var UpsellInstallServices_ProductCardForUpsell = ((/* unused pure expression or super */ null && (ProductCardForUpsell)));

// EXTERNAL MODULE: ./components/ProductDetail/v3/AddToCart/utils.js
var AddToCart_utils = __webpack_require__(29885);
// EXTERNAL MODULE: ./components/cart/CartInfo.jsx
var CartInfo = __webpack_require__(65143);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
// EXTERNAL MODULE: ./utils/findStore.js
var findStore = __webpack_require__(42605);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(11310);
;// CONCATENATED MODULE: ./components/Shared/UpsellInstallServices/index.jsx































const UpSellInstallServices = (param)=>{
    let { authData ={} , isRequireToLookupFullData =false , upSellProductData =[] , occupyFullWidth =false  } = param;
    var ref;
    const learnMoreRef = (0,react.useRef)(null);
    const slickRef = (0,react.useRef)(null);
    const { cart  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { isAuth , user: { firstName =""  } = {}  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { utilityLocation =""  } = (0,es/* useSelector */.v9)(locationSlice/* locationState */._n);
    const { consolidatedZipCodes =[]  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,localization/* getTranslations */.F)(t);
    const { search ="Search"  } = staticText;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [upSellData, setUpSellData] = (0,react.useState)([]);
    const [showUpSellModule, setShowUpSellModule] = (0,react.useState)(false);
    const [zipCodeVal, setZipCodeVal] = (0,react.useState)(utilityLocation);
    const [showInput, setShowInput] = (0,react.useState)(utilityLocation ? false : true);
    const [isServiceAvailable, setIsServiceAvailable] = (0,react.useState)(true);
    const [loading, setLoading] = (0,react.useState)(true);
    const [isUpsellDataAvailable, setIsUpsellDatAvailable] = (0,react.useState)(false);
    const [isDataAvailToProceed, setIsDataAvailToProceed] = (0,react.useState)(false);
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [inventoryUpdate, setInventoryUpdate] = (0,react.useState)(0);
    const [showRecommended, setShowRecommended] = (0,react.useState)(true);
    const [width] = (0,hooks_useWindowResize/* default */.Z)();
    const checkCity = async ()=>{
        const pincodeValue = await (0,cartHelper/* getPincode */.pf)();
        if (pincodeValue) {
            let details = {
                state: "",
                city: ""
            };
            const resp = await (0,findStore/* getDetailsFromZipCode */.k_)(pincodeValue);
            if (resp !== 400) {
                var ref, ref1, ref2, ref3;
                var ref4, ref5;
                details = {
                    state: (ref4 = resp === null || resp === void 0 ? void 0 : (ref = resp.result) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.state) !== null && ref4 !== void 0 ? ref4 : "",
                    city: (ref5 = resp === null || resp === void 0 ? void 0 : (ref2 = resp.result) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.city) !== null && ref5 !== void 0 ? ref5 : ""
                };
                if (width < 992 && constants.stateWithCities.findIndex((ele)=>{
                    return ele.state === details.state && ele.city === details.city;
                }) > -1) {
                    setShowRecommended(false);
                } else {
                    setShowRecommended(true);
                }
            }
        }
    };
    (0,react.useEffect)(()=>{
        checkCity();
    }, [
        width
    ]);
    (0,react.useEffect)(()=>{
        if (utilityLocation) setZipCodeVal(utilityLocation);
    }, [
        utilityLocation
    ]);
    const upsellHeaderCLickHandler = (e)=>{
        e.preventDefault();
        const { target: { href ="" , textContent =""  } = {}  } = e;
        (0,analytics/* addAnalyticsForFreeServices */.Sr)(textContent.toLowerCase(), href);
        window.open(href);
    };
    const { headerAuthData: { userTitleUpSell ="" , zipLabelUpSell ="" , zipChangeLabelUpSell =""  } = {} , productCard: productCardAuthData = {} , upSellServiceData: { presetConfigsUpSell: presetConfigs = "" , swatchUrlUpSell: swatchUrl = "" , jsonFilePathUpSell ="" , isForPostPurchase =false , recommendationTitle ="" , selectedTitle ="" , serviceAvailableTitleUpSell ="" , supportContactLabel ="1-800-103-2244"  } = {}  } = (0,helper.getUpSellAuthData)(authData, isRequireToLookupFullData);
    (0,react.useEffect)(()=>{
        let upSellHeaderElement = null;
        setTimeout(()=>{
            if (learnMoreRef === null || learnMoreRef === void 0 ? void 0 : learnMoreRef.current) {
                var ref;
                upSellHeaderElement = learnMoreRef === null || learnMoreRef === void 0 ? void 0 : (ref = learnMoreRef.current) === null || ref === void 0 ? void 0 : ref.querySelector("a");
                upSellHeaderElement === null || upSellHeaderElement === void 0 ? void 0 : upSellHeaderElement.addEventListener("click", upsellHeaderCLickHandler);
            }
        }, constant/* WAIT_TIME_FOR_LEAR_MORE */.L9);
        if (!zipCodeVal) setZipCodeVal(localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("currentZipCode"));
        return ()=>{
            upSellHeaderElement === null || upSellHeaderElement === void 0 ? void 0 : upSellHeaderElement.removeEventListener("click", upsellHeaderCLickHandler);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(cart) && !isForPostPurchase) {
            const { lineItems =[]  } = cart;
            if (lineItems.length) {
                fetchSkusBasedOnLineItems();
            } else {
                setIsDataAvailToProceed(false);
                setLoading(false);
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref = cart.lineItems) === null || ref === void 0 ? void 0 : ref.length,
        isAuth
    ]);
    (0,react.useEffect)(()=>{
        if (isForPostPurchase) {
            processWithPostPurchaseData();
        } else {
            if (isRequireToLookupFullData) {
                setShowUpSellModule(false);
            }
        }
    }, [
        isForPostPurchase
    ]);
    const processWithPostPurchaseData = async ()=>{
        if (upSellProductData.length) {
            const { productItems =[] , brandName , currency  } = await (0,helper.getProcessedProductInfoBasedOnLineItems)(upSellProductData);
            mapProductDataWithServicesData(productItems, brandName, currency);
        }
        return null;
    };
    const fetchSkusBasedOnLineItems = async ()=>{
        (0,helper.calculateCartData)({
            cart: (0,helper.sanitizeDOMString)(cart)
        }, true).then((res)=>{
            const { cartItems , brandName , cart: { price: { currency =currencySign  } = {}  } = {}  } = res;
            mapProductDataWithServicesData(cartItems, brandName, currency);
        });
    };
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const currency = get_default()(config, "internationalization.currencySign", "");
            setCurrencySign(currency);
        });
    }, []);
    const [pincode, setPincode] = (0,react.useState)("");
    const getCookieValue = (name)=>{
        var ref;
        return ((ref = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")) === null || ref === void 0 ? void 0 : ref.pop()) || "";
    };
    const getUserPincode = ()=>{
        dispatch((0,genericSlice/* getUserProfile */.et)()).unwrap().then((res)=>{
            let userPincode = "";
            var _addresses;
            const addresses = (_addresses = res.addresses) !== null && _addresses !== void 0 ? _addresses : [];
            if (addresses[0]) {
                var _postalCode;
                userPincode = (_postalCode = addresses[0].postalCode) !== null && _postalCode !== void 0 ? _postalCode : "";
            }
            setPincode(userPincode);
        });
    };
    (0,react.useEffect)(()=>{
        const availablePincode = getCookieValue("pincode");
        if (availablePincode) {
            setPincode(availablePincode);
        } else if (isAuth) {
            getUserPincode();
        }
    }, [
        isAuth
    ]);
    const [warehouse, setWarehouses] = (0,react.useState)();
    const mapProductDataWithServicesData = async function() {
        let productItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], lwAppName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : currencySign;
        if (!productItems.length) {
            setIsDataAvailToProceed(false);
            return;
        }
        const persona = (0,helper.getUserPersona)();
        const productCartItems = productItems.filter((item)=>{
            return (item === null || item === void 0 ? void 0 : item.category) !== "Install Services";
        });
        const installServicesSkus = [];
        productCartItems.forEach((item)=>{
            const { associatedServices =[]  } = item;
            if (associatedServices.length) {
                installServicesSkus.push(...associatedServices);
            }
        });
        const productAndServiceData = productCartItems.map((item)=>({
                cartProductData: item
            }));
        const parentSkus = productAndServiceData.map((item)=>{
            var ref;
            return item === null || item === void 0 ? void 0 : (ref = item.cartProductData) === null || ref === void 0 ? void 0 : ref.sku;
        });
        const recommendations = await (0,api/* getProductBySkus */.Ss)(parentSkus, "sku_s,CrossSellRecommendationSKUList_ss");
        const listOfRequiredSkus = recommendations.filter((item)=>item.CrossSellRecommendationSKUList_ss).map((item)=>({
                parentSku: item.sku_s,
                requiredSkus: item.CrossSellRecommendationSKUList_ss
            }));
        const requiredSkus = listOfRequiredSkus.map((item)=>item.requiredSkus).flat(1);
        var ref;
        // Executing second API...
        const { data ={}  } = (ref = await (0,api/* getProductDataFromSkuIds */.fh)(persona, requiredSkus, lwAppName)) !== null && ref !== void 0 ? ref : {};
        const skuidString = requiredSkus.join(",");
        if (!isEmpty_default()(data) && skuidString) {
            const { response: { docs: requiredSkusProductData = []  } = {}  } = data;
            var ref1;
            const { data: { results: productInventory = []  } = {}  } = (ref1 = await (0,api/* getProductInventory */.o)(skuidString)) !== null && ref1 !== void 0 ? ref1 : {};
            if (requiredSkusProductData.length) {
                for (const item of listOfRequiredSkus){
                    const index = parentSkus.indexOf(item.parentSku);
                    if (index > -1) {
                        const requiredItemsProductData = requiredSkusProductData.filter((productItem)=>{
                            var ref;
                            return (ref = item.requiredSkus) === null || ref === void 0 ? void 0 : ref.includes(productItem.sku_s);
                        });
                        requiredItemsProductData.forEach(async (requiredProItem, index)=>{
                            var ref, ref1;
                            const payload = {
                                pincode,
                                qty: 1,
                                mastervariantkey: productAndServiceData.length && ((ref = productAndServiceData[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.cartProductData) === null || ref1 === void 0 ? void 0 : ref1.masterVariantKey),
                                sku: requiredProItem.sku_s,
                                type: "Sales"
                            };
                            let etaData = await (0,utils_cart/* getETACached */.X3)(false, payload, false);
                            const { result: { data: { warehouse =[]  } = {}  } = {}  } = etaData;
                            requiredItemsProductData[index].warehouse = warehouse;
                            requiredItemsProductData[index].availableQuantity = (warehouse === null || warehouse === void 0 ? void 0 : warehouse.reduce((total, warehouse)=>total + warehouse.availableQty, 0)) || 0;
                            setInventoryUpdate((prevCount)=>prevCount + 1);
                        });
                        productAndServiceData[index].requiredItems = requiredItemsProductData;
                    }
                }
            }
        }
        const filteredProductAndServiceData = productAndServiceData.filter((item)=>{
            var ref;
            return (item === null || item === void 0 ? void 0 : (ref = item.requiredItems) === null || ref === void 0 ? void 0 : ref.length) || !isEmpty_default()(item === null || item === void 0 ? void 0 : item.installServiceData);
        });
        setIsUpsellDatAvailable(filteredProductAndServiceData.length);
        setUpSellData(filteredProductAndServiceData);
        setLoading(false);
        setIsDataAvailToProceed(true);
        setUtilityInfo();
    };
    const addServiceToCart = async (items)=>{
        (0,AddToCart_utils/* addToCart */.Xq)(items, false, "").catch((err)=>{
            console.log(err, "err");
        });
    };
    const handleAddToCart = (item, serviceQuantity)=>{
        const { installServiceData: { skuId ="" , customerBrand ="" , quantity =1  } = {}  } = item;
        addServiceToCart([
            {
                sku: skuId,
                quantity: isEmpty_default()(serviceQuantity) ? quantity : serviceQuantity[skuId],
                brand: customerBrand
            }
        ]);
    };
    const setUtilityInfo = function() {
        let showModule = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        setIsServiceAvailable(showModule);
        setShowInput(false);
        dispatch((0,locationSlice/* setUtilityLocation */.NL)({
            utilityLocation: zipCodeVal
        }));
        localStorage.setItem("currentZipCode", zipCodeVal);
    };
    if (!loading && isDataAvailToProceed && (upSellData === null || upSellData === void 0 ? void 0 : upSellData.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_module_default()).upsellmodal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "upsell-modal ".concat(isForPostPurchase && !occupyFullWidth ? "upsellmodal-order-history" : ""),
                children: [
                    showRecommended && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "upsell-modal-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "upsell-modal-header__title",
                            children: userTitleUpSell
                        })
                    }),
                    isUpsellDataAvailable && (upSellData === null || upSellData === void 0 ? void 0 : upSellData.length) > 0 && showRecommended ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallServiceCarousalSlick/* default */.Z, {
                        upSellData: upSellData,
                        authData: (0,helper.getUpSellAuthData)(authData, isRequireToLookupFullData),
                        handleAddToCart: handleAddToCart,
                        slickRef: slickRef,
                        currency: currencySign,
                        addServiceToCart: addServiceToCart,
                        inventoryUpdate: inventoryUpdate
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartInfo/* default */.Z, {
                        i18n: staticText,
                        supportLine: supportContactLabel
                    })
                ]
            })
        });
    }
    // else return <ProductCardForUpsell authData={productCardAuthData} />
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).upsellmodal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "upsell-modal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartInfo/* default */.Z, {
                i18n: staticText,
                supportLine: supportContactLabel
            })
        })
    });
};
/* harmony default export */ var UpsellInstallServices = (UpSellInstallServices);


/***/ }),

/***/ 65143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24899);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29063);





const CartInfo = (param)=>{
    let { i18n ={} , supportLine =[]  } = param;
    const { isAuth  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_3__/* .selectAuthState */ ._9);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const onClickSignIn = ()=>{
        if (!isAuth) {
            (0,_analytics__WEBPACK_IMPORTED_MODULE_4__/* .pushAnalyticsObjToDataLayer */ .zY)({
                "eventAction": "cart:landing page:sign in",
                "eventName": "cart:landing page:sign in",
                "eventType": "navigation",
                "eventMsg": "n/a",
                "eventStatus": "n/a",
                "internalLinkName": "sign in",
                "internalLinkPosition": "cart",
                "internalLinkType": "cart:navigation",
                "internalLinkZoneName": "cart:landing page:order summary",
                "internalLinkURL": "n/a",
                "clickInternalLinks": "true"
            });
            dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_3__/* .setAuthModalVisibility */ .LY)({
                show: true
            }));
        }
    };
    const onClickSignUp = ()=>{
        (0,_analytics__WEBPACK_IMPORTED_MODULE_4__/* .pushAnalyticsObjToDataLayer */ .zY)({
            "eventAction": "cart:landing page:create an account",
            "eventName": "cart:landing page:create an account",
            "eventType": "navigation",
            "eventMsg": "n/a",
            "eventStatus": "n/a",
            "internalLinkName": "create an account",
            "internalLinkPosition": "cart",
            "internalLinkType": "cart:navigation",
            "internalLinkZoneName": "cart:landing page:order summary",
            "internalLinkURL": "n/a",
            "clickInternalLinks": "true"
        });
        dispatch((0,_store_features_authSlice__WEBPACK_IMPORTED_MODULE_3__/* .setAuthModalVisibility */ .LY)({
            show: true,
            active: 1
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "cart-info",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                !isAuth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "cart-info__desc",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "gbh-data-layer",
                            tabIndex: "0",
                            role: "link",
                            onClick: onClickSignIn,
                            children: "".concat(i18n.signIn, " ")
                        }),
                        "".concat(i18n.or, " "),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "gbh-data-layer",
                            tabIndex: "0",
                            role: "link",
                            onClick: onClickSignUp,
                            children: i18n.createCartAccount
                        }),
                        " ".concat(i18n.saveYourCart)
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "cart-info__title",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                " ",
                                "".concat(i18n.needHelpOrder),
                                " ",
                                "".concat(i18n.callSupport, " "),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "cart-info__link",
                            href: "tel:".concat(supportLine),
                            onClick: ()=>(0,_analytics__WEBPACK_IMPORTED_MODULE_4__/* .addAnalyticsCallSupportCheckout */ .eY)(supportLine, "cart"),
                            children: supportLine
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CartInfo);


/***/ }),

/***/ 29063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qz": function() { return /* binding */ addAnalyticsEditCart; },
/* harmony export */   "eY": function() { return /* binding */ addAnalyticsCallSupportCheckout; },
/* harmony export */   "wt": function() { return /* binding */ continueCheckoutEventInfo; },
/* harmony export */   "zY": function() { return /* binding */ pushAnalyticsObjToDataLayer; }
/* harmony export */ });
const addAnalyticsEditCart = (cartPage)=>{
    var ref, ref1;
    const { adobeDataLayer: {} = {}  } = window;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const productInfo = page === null || page === void 0 ? void 0 : (ref = page.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.map((i)=>{
        return i === null || i === void 0 ? void 0 : i.productInfo;
    });
    const eventInfo = {
        eventAction: "checkout:edit cart",
        eventName: "checkout:edit cart",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "edit cart",
        internalLinkPosition: "checkout",
        internalLinkType: "checkout:navigation",
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: cartPage,
        clickInternalLinks: "true",
        internalLinkZoneName: "checkout:header:navigation"
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsCallSupportCheckout = (contactNumber, source)=>{
    const { adobeDataLayer: {} = {}  } = window;
    let eventInfo = {
        clickInternalLinks: "true",
        eventAction: "checkout:need help with your order:sales team number",
        eventName: "checkout:need help with your order:sales team number",
        eventMsg: "n/a",
        eventStatus: "success",
        eventType: "help support",
        internalLinkName: contactNumber,
        internalLinkPosition: "help support",
        internalLinkType: "checkout:call supports",
        internalLinkURL: "tel:".concat(contactNumber.replace(/Kohler India:/g, "")),
        internalLinkZoneName: "checkout:need help with your order"
    };
    if (source === "cart") {
        eventInfo = {
            clickInternalLinks: "true",
            eventAction: "".concat(source, ":landing page:main content area:call support"),
            eventName: "".concat(source, ":landing page:main content area:call support"),
            eventType: "call support",
            internalLinkName: contactNumber,
            internalLinkPosition: "".concat(source),
            internalLinkType: "".concat(source, ":call support"),
            internalLinkURL: "tel:".concat(contactNumber),
            internalLinkZoneName: "".concat(source, ":landing page:main content area")
        };
    }
    pushAnalyticsObjToDataLayer(eventInfo);
};
const continueCheckoutEventInfo = (checkoutUrl)=>{
    const { adobeDataLayer: {} = {}  } = window;
    const eventInfo = {
        eventAction: "cart:landing page:checkout",
        eventName: "cart:landing page:checkout",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "checkout",
        internalLinkPosition: "cart",
        internalLinkType: "cart:navigation",
        internalLinkZoneName: "cart:landing page:order summary",
        internalLinkURL: checkoutUrl ? (checkoutUrl.indexOf("http") === -1 ? window.location.origin : "") + checkoutUrl : "n/a",
        clickInternalLinks: "true"
    };
    pushAnalyticsObjToDataLayer(eventInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    if (productInfo.length > 0) page["productInfo"] = productInfo;
    window.adobeDataLayer.push({
        event,
        eventInfo,
        page
    });
};


/***/ }),

/***/ 9656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leftside":"ParentProductCard_leftside__nT11_"};

/***/ })

}]);